// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import en_us from './en_us'
import uk from './uk'

const SUPPORTED = { en: en_us, uk }
const DATE_LOCALE = { en: 'en-US', uk: 'uk-UA' }
const STORAGE_KEY = 'polis_admin_lang'

function detectLang() {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && SUPPORTED[stored]) return stored
  }
  if (typeof navigator !== 'undefined') {
    const lang = (navigator.languages?.[0] || navigator.language || '').split('-')[0].toLowerCase()
    if (SUPPORTED[lang]) return lang
  }
  return 'en'
}

export function setLanguage(lang) {
  if (typeof localStorage !== 'undefined' && SUPPORTED[lang]) {
    localStorage.setItem(STORAGE_KEY, lang)
  }
  window.location.reload()
}

export const currentLang = detectLang()
export const dateLocale = DATE_LOCALE[currentLang] || 'en-US'

const s = { ...en_us, ...(SUPPORTED[currentLang] || {}) }

function f(key) {
  key = key.replace(/\s+$/, '').replace(/^\s+/, '')
  return s[key] !== undefined ? s[key] : key
}

export default f
